/**
 * Document type definitions and default prefixes for the numbering system.
 *
 * Separated from invoiceNumbering.ts to avoid circular dependencies —
 * appSettings.tsx imports these types for the CompanyProfile shape,
 * and invoiceNumbering.ts imports from appSettings for the hook.
 */

export const DOCUMENT_TYPES = [
  "invoice",
  "salesOrder",
  "purchaseOrder",
  "creditNote",
  "payment",
  "expense",
] as const;

export type DocumentType = (typeof DOCUMENT_TYPES)[number];

export type DocumentPrefixes = Record<DocumentType, string>;

export const DEFAULT_PREFIXES: DocumentPrefixes = {
  invoice: "INV-",
  salesOrder: "SO-",
  purchaseOrder: "PO-",
  creditNote: "CN-",
  payment: "PAY-",
  expense: "EXP-",
};

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  invoice: "Invoice",
  salesOrder: "Sales Order",
  purchaseOrder: "Purchase Order",
  creditNote: "Credit Note",
  payment: "Payment",
  expense: "Expense",
};
